import { intervalToDuration } from 'date-fns';

export const getParsedErrorMessage = (error: unknown): string => {
  try {
    const errorMessage = (
      error as { response: { data: { error: { message: string } } } }
    ).response.data.error.message;

    const errorObject = errorMessage.substring(
      errorMessage.indexOf('{'),
      errorMessage.length,
    );

    const { params } = JSON.parse(errorObject) as {
      params: { resendableInMs?: number };
    };

    if (params.resendableInMs) {
      // intervalToDuration needs {start, end}
      const duration = intervalToDuration({
        start: 0,
        end: params.resendableInMs,
      });
      // Produce a human-readable string, e.g. "2 minutes 30 seconds"
      const parts: string[] = [];

      if (duration.minutes) parts.push(`${duration.minutes} minute(s)`);
      if (duration.seconds) parts.push(`${duration.seconds} second(s)`);

      return `Try again in ${parts.join(' ') || 'a moment'}`;

      // return `Try again in ${intervalToDuration(params.resendableInMs)}`;
    }

    if (typeof params === 'string') {
      return params;
    }

    return JSON.stringify(params);
  } catch (_error) {
    return '';
  }
};
